import React from 'react';
import { Input, Button, Select, Textarea, PaperClip } from 'components';
import { connect } from 'react-redux';
import { JobApplicationService, AuthService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router';
import { BgLogin, LoginImage, LoginImage2, WhiteImage, PersonWhiteImage, DocumentWhiteImage, DocumentWhiteImageCheck, LogoSplendor, Logo } from 'assets/img';
import { ArrowLeft, LogoutIcon, CheckGreenIcon } from 'assets/icons';
import { Link } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class JobApplication extends React.Component<Props> {

	state = {
		form: {
			name: '',
			lastname: '',
			document_type_id: Constants.DOCUMENT_TYPES.V,
			document: '',
			phone: '',
			email: '',
			address: '',
			work_experience: '',
			photo: '',
			curriculum: ''
		},
		document_types: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Trabaja con Nosotros',
				onBack: null
			}
		});

		this.load();
	}

	load = async () => {
		const res: any = await AuthService.getDocumentTypes();
		this.setState({
			document_types: res.document_types.filter((item: any) => item.id == Constants.DOCUMENT_TYPES.V || item.id == Constants.DOCUMENT_TYPES.E)
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (!this.state.form.photo) {
			Globals.showError("Por favor, ingrese su fotografía");
			return;
		}

		await JobApplicationService.create({
			hasFile: true,
			...this.state.form,
			// @ts-ignore,
			photo: this.state.form.photo?.value || '',
			// @ts-ignore,
			curriculum: this.state.form.curriculum?.value || '',
		});
		Globals.showSuccess("Se ha enviado correctamente su postulación");
		this.setState({
			form: {
				name: '',
				lastname: '',
				document_type_id: Constants.DOCUMENT_TYPES.V,
				document: '',
				phone: '',
				email: '',
				address: '',
				work_experience: ''
			}
		});
	}
	
	render() {
		return (
			<div id="job-application">
				<div className="container-header">
					<div className="row">
						<div className="col-md-6 logo-splendor">
							<a href="https://splendorve.com/">
								<img src={ LogoSplendor } />
							</a>
						</div>
						<div className="col-md-6 logo-servizi">
							<a href="https://splendorve.com/servizi-servicio-de-limpieza/">
								<img src={ Logo } className="servizi" />
							</a>
						</div>
					</div>
				</div>
				<div className="container-black">
					<div className="row container-form">
						<form className="col-lg-12" onSubmit={ this.submit }>
							<div className="row-title">
								<h3 className="title-green">Trabaja con Nosotros</h3>
							</div>
							<h3 className="subtitle">Datos personales</h3>
							<div className="row">
								<div className="col-md-6">
									<Input
										color="white"
										value={ this.state.form.name }
										name="name" 
										placeholder="Nombre"
										onChange={ this.change } />
								</div>
								<div className="col-md-6">
									<Input
										color="white"
										value={ this.state.form.lastname }
										name="lastname" 
										placeholder="Apellido"
										onChange={ this.change } />
								</div>
								<div className="col-md-6">
									<div className="container-document">
										<div className="select-document">
											<Select
												placeholder="Tipo de Documento"
												name="document_type_id"
												onChange={ (e: any) => {
													this.setState({
														form: {
															...this.state.form,
															document_type_id: parseInt(e.target.value)
														}
													});
												} }
												value={ this.state.form.document_type_id }
												options={ this.state.document_types.map((i: any) => {
													return {
														value: i.id,
														label: i.name
													}
												}) } />
										</div>
										<div>
											<Input
												color="white"
												value={ this.state.form.document }
												name="document" 
												placeholder="Cédula"
												onChange={ this.change } />
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<Input
										color="white"
										value={ this.state.form.phone }
										name="phone" 
										maxLength={ 11 }
										placeholder="Teléfono - Ej. 04121234567"
										onChange={ this.change } />
								</div>
								<div className="col-md-6">
									<Input
										color="white"
										value={ this.state.form.email }
										name="email" 
										placeholder="Correo"
										onChange={ this.change } />
								</div>
								<div className="col-md-12">
									<Textarea
										className="form-group-textarea"
										rows={ 3 }
										label="Dirección"
										name="address"
										onChange={ this.change }
					                    value={ this.state.form.address } />
								</div>
								<div className="col-md-12">
									<Textarea
										className="form-group-textarea"
										rows={ 3 }
										label="Experiencia Laboral"
										name="work_experience"
										onChange={ this.change }
					                    value={ this.state.form.work_experience } />
								</div>
								<div className="col-md-6 text-center container-paperclip">
									{/*
									// @ts-ignore */}
									<img className={ `selected-image ${ (this.state.form.photo) ? '' : 'inactive' }` } src={ this.state.form.photo?.dataURL || PersonWhiteImage } />
									<PaperClip
										className="paperclip-image"
										value={ this.state.form.photo }
										pendingText="Adjuntar Fotografía"
										successImg={ CheckGreenIcon }
										onChange={ (e: any) => {
											this.setState({
												form: {
													...this.state.form,
													photo: e.target
												}
											})
										} }>
									</PaperClip>
								</div>
								<div className="col-md-6 text-center container-paperclip">
									{/*
									// @ts-ignore */}
									<img className={ `selected-image ${ (this.state.form.curriculum) ? '' : 'inactive' }` } src={ this.state.form.curriculum?.dataURL ? DocumentWhiteImageCheck : DocumentWhiteImage } />
									<PaperClip
										formats={ ['pdf','doc','docx'] }
										className="paperclip-image"
										pendingText="Adjuntar Curriculo (Opcional)"
										value={ this.state.form.curriculum }
										successImg={ CheckGreenIcon }
										onChange={ (e: any) => {
											this.setState({
												form: {
													...this.state.form,
													curriculum: e.target
												}
											})
										} }>
									</PaperClip>
								</div>
							</div>
							<div className="container-input container-btn-submit text-center">
								<Button type="submit">
									Enviar
								</Button>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default connect()(JobApplication);